import React from "react";
import DisasterSection from "./DisasterRecovery";
import Hero from "./hero";
import Cards from "./Cards";


function Index() {
    return (
        <div>
            <Hero />
            <DisasterSection />
            <Cards />

        </div>

    );
}

export default Index;